import React from "react";
import Banner from "./Banner"; // Adjust the path based on your file structure
import EdufulnessLanding from "./landing";

const Home = () => {
  return (
    <div>
      <EdufulnessLanding />
    </div>
  );
};

export default Home;